import React from 'react';

import { About, Footer, Header, Skills, Testimonial, Work, TeamMember, Inscription } from './container';
import { Navbar } from './components';
import './App.scss';

const App = () => (
  <div className="app">
    <Navbar />
    <Header />
    <About />
    <Work />
    <Skills />
    <Testimonial />
    <Footer />
    <TeamMember />
    <Inscription />
  </div>
);

export default App;
